module.exports = __webpack_public_path__ + "static/media/main idea.5cb1824a.mp3";